import React, { useState, useEffect } from 'react'
import './page-layout.scss'
import MenuActivity from '../../molecules/menuActivity/menuActivity'
import useMediaQuery from '../../../utils/useMediaQuery'
import { HamburgerElastic } from 'react-animated-burgers'

import logo from '../../../assets/images/home/Vivel_el_cole.png'
import { navigate } from 'gatsby'
import SEO from './../../../shared/seo'

import { lte } from 'lodash'
import Footer from '../../../shared/components/molecules/footer/footer'

const PageLayout = ({ children, isLogged = false, mobile }) => {
  const [isActive, setIsActive] = useState(false)
  const [localView, setLocalView] = useState('')
  const [activeMenu, setActiveMenu] = useState(false)
  const isMobile = useMediaQuery()

  const toggleButton = () => {
    setIsActive(prevState => !prevState)
    setActiveMenu(prevState => !prevState)
  }


  useEffect(() => {
    let path = window.location.pathname.split('/')
    if (path[path.length - 1] === '') path.pop()
    if (path[path.length - 1] === '') {
      setLocalView('Inicio')
    } else {
      let host = path[path.length - 1]
      host = host.charAt(0).toUpperCase() + host.slice(1)
      host = host.replace(/-/g, ' ')
      setLocalView(host)
    }

  }, [])

  // -------------Detecta Cuando baja el scroll oculta el logo----------------
  const [scrollY, setSrollY] = useState(0)

  function scrollPosition() {
      setSrollY(window.pageYOffset)
  }

  useEffect(() => {
      function watchScroll() {
          window.addEventListener("scroll", scrollPosition);
      }
      watchScroll();
      return () => {
          window.removeEventListener("scroll", scrollPosition)
      }
  })
// ---------------------------------------------------------------------------

  return (
    <>
      <SEO title='Vive el Cole con Nosotras'
           description='Nosotras también extrañamos el colegio y poder compartir contigo. Por eso, creamos un espacio increíble para que juntas podamos aprender, divertirnos y muchas sorpresas más.' />
      <header className='f-activity-header'>
        <div className='f-activity-header__wrapper'>
          <div
            className={`f-activity-header__logo ${scrollY > 200 && 'hidden'}`}
            onClick={() => {
              navigate('/')
            }}
          >
            <img src={logo} align='Vive el Cole Logo' />
          </div>
          {isLogged && !isMobile && <MenuActivity />}
          {isLogged && isMobile && (
            <p className='f-activity-header__text'>{localView}</p>
          )}
          {isLogged && isMobile && (
            <>
              <HamburgerElastic
                barColor='#FD3AB2'
                {...{ isActive, toggleButton }}
              />
              <MenuActivity active={activeMenu} />
            </>
          )}
        </div>
      </header>
      <div>
        <main>{children}</main>
        <Footer
          // setCommondModal={setCommondModal}
          mobile={mobile}
        />
      </div>
    </>
  )
}

export default PageLayout
